/*
 * @Date: 2020-07-22 10:13:03
 * @LastEditTime: 2020-07-22 14:05:14
 * @Description: 代理主机 api
 */ 

import request from '@/utils/request.js'

export function proxyList(params) {
    return request({
        url: '/api/channel/proxy/',
        method: 'get',
        params
    })
}

export function proxyCreate(data) {
    return request({
        url: '/api/channel/proxy/',
        method: 'post',
        data
    })
}

export function proxyUpdate(data) {
    return request({
        url: `/api/channel/proxy/${data.id}/`,
        method: 'put',
        data
    })
}

export function proxyDelete(data) {
    return request({
        url: `/api/channel/proxy/${data.id}`,
        method: 'delete'
    })
}
